import React, { useEffect, createElement } from 'react';
import AdvertorialGlpInvestigationC from '../components/AdvertorialGlpInvestigationC';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpInvestigationCPage() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv2
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Ozempic Depression Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'ReadHalfArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'ReadFullArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18568" data-mp="14skkcxxb33q">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18569" data-mp="1495r53kkutx">
        <Helmet data-id="element-18570" data-mp="16vl3qwpcemp">
          <title data-id="element-18571" data-mp="64djwoh09dgz">GLP-1 DEPRESSION: REAL SIDE EFFECT OR COINCIDENCE?</title>
          <meta property="og:title" content="GLP-1 DEPRESSION: REAL SIDE EFFECT OR COINCIDENCE?" data-id="element-18572" data-mp="66hzi3o9o0x3" />
          <meta property="og:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18573" data-mp="a3e0s1fxa61c" />
          <meta property="og:type" content="article" data-id="element-18574" data-mp="362523v4cwqtl" />
          <meta property="og:url" content={window.location.href} data-id="element-18575" data-mp="32131b9usk6pi" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18576" data-mp="323pb7g55myaw" />
          <meta property="og:image:width" content="1200" data-id="element-18577" data-mp="2sagua4154oif" />
          <meta property="og:image:height" content="630" data-id="element-18578" data-mp="2ncfb7j3psp6y" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18579" data-mp="2ne0310yn9u14" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18580" data-mp="2icap9dk1f29c" />
          <meta name="twitter:title" content="GLP-1 DEPRESSION: REAL SIDE EFFECT OR COINCIDENCE?" data-id="element-18581" data-mp="2ebh2inibzti1" />
          <meta name="twitter:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18582" data-mp="29cxgyo7ngjq7" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18583" data-mp="30frlk6ardxyc" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18584" data-mp="30gkk4jzkdh5e" />
        </Helmet>
        <AdvertorialGlpInvestigationC data-id="element-18585" data-mp="2rfw45jqm16pv" />
      </div>
    </HelmetProvider>;
}